import clsx from 'clsx'
import React from 'react'
import { useNode } from '@craftjs/core'

import { Text } from '@wartek-id/text'

const Container = ({ children }) => {
  const {
    connectors: { connect, drag },
    isSelected,
  } = useNode((node) => ({
    isSelected: node.events.selected,
  }))

  return (
    <div
      // @ts-expect-error
      ref={(ref) => connect(drag(ref!))}
      className={clsx(
        'widget-component',
        'widget-component--container',
        'p-3 mb-4 bg-surface-default last:-mb-4',
        isSelected && 'widget-component__selected'
      )}
    >
      {!children && (
        <Text
          color="informational"
          className="italic mb-0 text-center border border-dashed p-4"
        >
          empty container
        </Text>
      )}
      {children}
    </div>
  )
}

export default Container
